import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageGlyph } from './treeIcons';

/**
 * An empty tree: the house sidebar empty state (muted glyph in a circle, a
 * title, a hint) plus ONE low-emphasis "New document" action — in the stacked
 * layout the section header's own actions are hidden until hover, so an empty
 * section would otherwise offer no visible way in. It is also the drop target
 * for "move to the top of this (empty) tree".
 */
export default function SectionEmpty({ title, hint, onNewDocument, dropProps, dropActive }) {
  const { t } = useTranslation();
  return (
    <div className={`doc-section-empty${dropActive ? ' doc-section-empty--drop' : ''}`} {...dropProps}>
      <div className="sidebar-empty-icon-wrap">
        <div className="sidebar-empty-icon">
          <PageGlyph size={16} />
        </div>
      </div>
      <p className="mb-1 text-xs font-medium text-gray-600 dark:text-zinc-200">{title}</p>
      {hint && <p className="text-xs text-gray-500 dark:text-zinc-400">{hint}</p>}
      <button type="button" onClick={onNewDocument} className="doc-section-empty-action">
        {t('docSidebar.newDocument')}
      </button>
    </div>
  );
}
